import React, { Component, useState, useEffect, Fragment } from 'react';
import GDPRCookieSettingsSettingSection from '../Partials/gdpr-cookie-settings-setting-section/gdpr-cookie-settings-setting-section';
import classNames from 'classnames';
import T from 'i18n-react';

class ModuleGdprCookieSettingsCookieSettings extends React.Component {
  constructor(props) {
    super(props);

    let defaultLevel0Status, defaultLevel1Status, defaultLevel2Status, defaultLevel3Status;

    defaultLevel0Status = 2;

    if (this.props.defaultGDPRCookieValue === 3) {
      defaultLevel1Status = 1;
      defaultLevel2Status = 1;
      defaultLevel3Status = 1;
    }  
    else if (this.props.defaultGDPRCookieValue  === 2) {
      defaultLevel1Status = 1;
      defaultLevel2Status = 1;
      defaultLevel3Status = 0;
    }
    else if (this.props.defaultGDPRCookieValue  === 1) {
      defaultLevel1Status = 1;
      defaultLevel2Status = 0;
      defaultLevel3Status = 0;
    }
    else {
      defaultLevel1Status = 0;
      defaultLevel2Status = 0;
      defaultLevel3Status = 0;
    }

    //0 = not selected, 1 = selected, 2 = always selected
    this.state = {
      level0Status: defaultLevel0Status,
      level1Status: defaultLevel1Status,
      level2Status: defaultLevel2Status,
      level3Status: defaultLevel3Status
    };
  }

  componentDidMount() {
  }

  handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation(); 

    this.refs.lightbox.open();
  };

  level0ClickedHandler = (e) => {
    //e.preventDefault();
  };

  level1ClickedHandler = (e) => {
    //e.preventDefault();

    this.setState({
      level1Status: (this.state.level1Status === 0 ? 1 : 0),
      level2Status: 0,
      level3Status: 0
    });
  };

  level2ClickedHandler = (e) => {
    //e.preventDefault();

    this.setState({
      level1Status: 1,
      level2Status: (this.state.level2Status === 0 ? 1 : 0),
      level3Status: 0
    });
  };

  level3ClickedHandler = (e) => {
    //e.preventDefault();

    this.setState({
      level1Status: 1,
      level2Status: 1,
      level3Status: (this.state.level3Status === 0 ? 1 : 0)
    });
  };

  setGDPRCookieHandler = () => {
    let currentCookieLevel;

    if (this.state.level3Status === 1) {
      currentCookieLevel = 3;
    }  
    else if (this.state.level2Status === 1) {
      currentCookieLevel = 2;
    }
    else if (this.state.level1Status === 1) {
      currentCookieLevel = 1;
    }
    else {
      currentCookieLevel = 0;
    }

    this.props.setGDPRCookieValueHandler(currentCookieLevel);
  };

  render() {
    return (
      <div className="gdpr_cookie_settings_cookie_settings">
        <h2>
          {this.props.GDPRCookieSettingsHeading}
        </h2>
        <p dangerouslySetInnerHTML={{ __html: this.props.GDPRCookieSettingsBodyText }} className="component-content-editorial gdpr_cookie_settings_cookie_settings__ingress">
        </p>
        <div className="gdpr_cookie_settings_cookie_settings__main-section">
          <div>
            <GDPRCookieSettingsSettingSection {...this.props} sectionHeading={this.props.GDPRCookieSettingsLevel0Heading} sectionInfoText={this.props.GDPRCookieSettingsLevel0InfoText} checkedStatus={this.state.level0Status} toggleButtonClickedHandler={this.level0ClickedHandler} />
            <GDPRCookieSettingsSettingSection {...this.props} sectionHeading={this.props.GDPRCookieSettingsLevel1Heading} sectionInfoText={this.props.GDPRCookieSettingsLevel1InfoText} checkedStatus={this.state.level1Status} toggleButtonClickedHandler={this.level1ClickedHandler} />
            <GDPRCookieSettingsSettingSection {...this.props} sectionHeading={this.props.GDPRCookieSettingsLevel2Heading} sectionInfoText={this.props.GDPRCookieSettingsLevel2InfoText} checkedStatus={this.state.level2Status} toggleButtonClickedHandler={this.level2ClickedHandler} />
            <GDPRCookieSettingsSettingSection {...this.props} sectionHeading={this.props.GDPRCookieSettingsLevel3Heading} sectionInfoText={this.props.GDPRCookieSettingsLevel3InfoText} checkedStatus={this.state.level3Status} toggleButtonClickedHandler={this.level3ClickedHandler} />
          </div>
          <div className="gdpr_cookie_settings_cookie_settings__main-section__button-container">
            <button type="button" className="element-button button--solid--primary wider gdpr_cookie_settings_cookie_settings__main-section__button-container__button" onClick={this.setGDPRCookieHandler}>
              {this.props.GDPRCookieSettingsAcceptChoiceButtonText}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
export default ModuleGdprCookieSettingsCookieSettings;
